export default __webpack_public_path__ + "geburtstag-teaser-01.03a2e3f8527b9334231a534b7f723b4e.png";